import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CheckboxTree from 'react-checkbox-tree';
import _ from 'lodash';
// import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import clearFilterIcon from '../../../images/insight360/clear-field-icon_white.png';
import { PERSONA_FILTER_COUNT } from '../../../constants';

class DemographicFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: [],
      expanded: [],
      isNotVisible: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.demographics) {
      this.setState({ demographics: [] });
    } else if (this.props.demographics !== nextProps.demographics) {
      this.setState({ demographics: nextProps.demographics });
    }
    if (
      nextProps.index !== undefined &&
      nextProps.insight360PersonaFilter[nextProps.index] !== undefined
    ) {
      this.setState({
        checked:
          nextProps.insight360PersonaFilter[nextProps.index] !== ''
            ? [nextProps.insight360PersonaFilter[nextProps.index]]
            : [],
      });
    }
    if (nextProps.insight360PersonaFilter[nextProps.index] === '') {
      this.setState({ expanded: [] });
    }

    if (
      nextProps.index !== undefined &&
      nextProps.personaFilter !== undefined &&
      nextProps.personaFilter[nextProps.index] !== undefined
    ) {
      this.setState(
        {
          checked:
            nextProps.personaFilter[nextProps.index] !== ''
              ? [nextProps.personaFilter[nextProps.index]]
              : [],
        },
        () => {
          const expanded = _.findKey(this.props.filterOptions.data, arr => (
            _.some(arr, { keyword: this.state.checked[0] })
          ));
          this.setState({ expanded: [expanded] });
        },
      );
    }

    if (
      nextProps.index !== undefined &&
      nextProps.personaFilter !== undefined &&
      nextProps.personaFilter[nextProps.index] === ''
    ) {
      this.setState({ expanded: [] });
    }
  }

  componentDidMount() {
    this.didMountMethod();
  }

  didMountMethod = () => {
    if (
      this.props.index !== undefined &&
      this.props.personaFilter !== undefined &&
      this.props.personaFilter[this.props.index] !== undefined
    ) {
      this.setState(
        {
          checked:
            this.props.personaFilter[this.props.index] !== ''
              ? [this.props.personaFilter[this.props.index]]
              : [],
        },
        () => {
          const expanded = _.findKey(this.props.filterOptions.data, arr => (
            _.some(arr, { keyword: this.state.checked[0] })
          ));
          this.setState({ expanded: [expanded] });
        },
      );
    }

    if (
      this.props.index !== undefined &&
      this.props.personaFilter !== undefined &&
      this.props.personaFilter[this.props.index] === ''
    ) {
      this.setState({ expanded: [] });
    }

    if (
      window.innerWidth -
        Math.round(this.filterRef.getBoundingClientRect().left) <
      this.filterRef.offsetWidth
    ) {
      this.setState({ isNotVisible: true });
    }
  }

  makeFilterOptions = () => (
    this.props.filterOptions.data.filters.map(entry => (
      {
        value: entry,
        label: entry,
        children: this.props.filterOptions.data[entry].map(item => {
          if (item.title.length <= PERSONA_FILTER_COUNT) {
            return { value: item.keyword, label: item.title };
          }
          return {
            value: item.keyword,
            label: item.title.substr(0, PERSONA_FILTER_COUNT).concat('...'),
            title: item.title,
          };
        }),
      }
      ))
  );

  onChecked = checked => {
    if (checked.length === 0) {
      this.setState({ checked: [] }, () => {
        this.props.filterExpressionChanged(['']);
      });
    } else {
      const difference = this.diffArray(this.state.checked, checked);
      this.setState({ checked: difference }, () => {
        this.props.filterExpressionChanged(this.state.checked);
      });
    }
    // this.props.toggleFilter();
  };

  onExpanded = expanded => {
    if (expanded.length === 0) {
      this.setState({ expanded: [] });
    } else {
      const difference = this.diffArray(this.state.expanded, expanded);
      this.setState({ expanded: difference });
    }
  };

  diffArray = (arr1, arr2) => {
    const newArr = [];

    arr1.forEach(val => {
      if (arr2.indexOf(val) < 0) newArr.push(val);
    });

    arr2.forEach(val => {
      if (arr1.indexOf(val) < 0) newArr.push(val);
    });

    return newArr;
  };

  cancelFilterClick = () => {
    this.setState({ checked: this.state.checked }, () => {
      this.props.filterExpressionChanged(this.state.checked);
    });
  };

  render() {
    const nodes = this.makeFilterOptions(this.props.filterOptions);
    return (
      <div
        ref={el => (this.filterRef = el)}
        className={this.props.filterCssClass}
        style={{ right: this.state.isNotVisible ? '0' : '' }}
      >
        <div className="insight360_filter_header">
          <span className="insight360_filter_header_text">Filter</span>
          <img
            className="insight360_header_icons_img"
            src={clearFilterIcon}
            alt="filter"
            onClick={() => {
              this.cancelFilterClick();
            }}
          />
        </div>
        {this.props.filterOptions !== undefined ? (
          <CheckboxTree
            nodes={nodes}
            checked={this.state.checked}
            expanded={this.state.expanded}
            onCheck={checked => this.onChecked(checked)}
            onExpand={expanded => this.onExpanded(expanded)}
            onlyLeafCheckboxes
            showNodeTitle="true"
          />
        ) : (
          ''
        )}
      </div>
    );
  }
}

DemographicFilter.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
    }),
  }),
  filterOptions: PropTypes.shape({}),
  filterExpressionChanged: PropTypes.func,
  insight360PersonaFilter: PropTypes.arrayOf(PropTypes.string),
  index: PropTypes.number,
  demographics: PropTypes.arrayOf(PropTypes.object),
  personaFilter: PropTypes.arrayOf(PropTypes.string),
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    insight360PersonaFilter: state.insight360.insight360PersonaFilter,
    demographics: state.insight360.demographics,
  };
}

function mapDispatchToProps() {
  return {
    // brand360Actions: bindActionCreators(brand360Actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(DemographicFilter);
